"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getSize;
var _lodash = _interopRequireDefault(require("lodash.isfunction"));
var _mappings = require("../constants/mappings");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function getSize(size) {
  if ((0, _lodash["default"])(_mappings.sizesMap[size])) {
    return _mappings.sizesMap[size]();
  }
  return "font-size: ".concat(size);
}